



















































import Vue from 'vue';

import FreightService, { DatasetSpec } from '@/services/FreightService';

export default Vue.extend({
  name: 'Datasets',

  data: () => ({
    loading: false,
    search: '',
    headers: [
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      {
        text: 'Random Seed',
        align: 'end',
        value: 'seed',
      },
      {
        text: 'Origins',
        align: 'end',
        value: 'num_origins',
      },
      {
        text: 'Destinations',
        align: 'end',
        value: 'num_destinations',
      },
      {
        text: 'Sensors',
        align: 'end',
        value: 'num_sensors',
      },
      {
        text: 'Trucks',
        align: 'end',
        value: 'num_trucks',
      },
      {
        text: 'Start',
        align: 'start',
        value: 'timestamp_start',
        filterable: false,
      },
      {
        text: 'End',
        align: 'start',
        value: 'timestamp_end',
        filterable: false,
      },
      {
        text: 'Actions',
        align: 'start',
        value: 'actions',
        filterable: false,
      },
    ],
    datasets: [] as DatasetSpec[],
  }),

  created() {
    this.fetchDatasets();
  },

  methods: {
    fetchDatasets() {
      this.loading = true;
      return FreightService.listDatasets().then((datasets) => {
        this.loading = false;
        this.datasets = datasets;
      });
    },
    loadDataset(datasetSpec: DatasetSpec) {
      this.$store.dispatch('setActiveDataset', datasetSpec).then(() => {
        this.$router.push({
          name: 'Flow',
          query: { datasetId: datasetSpec.id },
        });
      });
    },
  },
});
